// eslint-disable-next-line import/prefer-default-export
export const dispatchSwitchAppFlowEvent = (detail) => {
  document.dispatchEvent(new CustomEvent('switch-app-flow', { detail }));
};
